export const getViewerWidth = () => {
	const width = window.innerWidth;

	if (width >= 1400) return 900;
	if (width >= 992) return width - 400;
	if (width >= 576) return width - 170;

	return width - 50;
};
